/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, Input, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

export interface MatrixResult {
  isSingleChoice: boolean | null;
  values: DataSource[];
}

export interface DataSource {
  key: string;
  value: Properties;
}

export interface Properties {
  name: string;
  description?: string;
}

export interface CustomModel {
  key: string;
  selected: boolean;
}

@Component({
  selector: 'formly-matrix-field',
  templateUrl: './formly-matrix-field.component.html',
  styleUrls: ['./formly-matrix-field.component.scss'],
})
export class FormlyMatrixFieldComponent extends FieldType implements OnInit {
  @Input() label: string;
  @Input() name: string;

  singleChoice = false;

  dataSourceX: DataSource[];
  dataSourceY: DataSource[];

  values: CustomModel[] = [];

  count;

  allSelectedByX: string[] = [];

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.count = 0;
    this.label = this.to.label;
    this.name = this.key.toString();

    const x = JSON.parse(this.to.dataSourceX) as MatrixResult;
    const y = JSON.parse(this.to.dataSourceY) as MatrixResult;

    this.dataSourceX = x.values;
    this.dataSourceY = y.values;

    this.singleChoice = y.isSingleChoice;

    if (this.to.required) {
      this.updateValidation();
    }

    this.dataSourceY.forEach((y) => {
      if (this.dataSourceX.length > 0) {
        this.dataSourceX.forEach((x) => {
          this.values.push({
            key: `${y.key}|${x.key}`,
            selected: false,
          } as CustomModel);
        });
      } else {
        this.values.push({
          key: `${y.key}|`,
          selected: false,
        });
      }
    });
  }

  onSingleSelectChange(xKey: string, { detail }) {
    this.values = this.values.map((item) => {
      if (item.key.includes(xKey)) {
        const isSelected = detail.selected.value.includes(item.key);
        return { ...item, selected: isSelected };
      } else {
        return item;
      }
    });

    this.count = this.values.filter((v) => v.selected).length;

    this.field.formControl.patchValue(JSON.stringify(this.values));

    if (this.to.required) {
      this.updateValidation();
    }
  }

  onMultiSelectChange(xKey: string, { detail }) {
    this.values = this.values.map((item) => {
      if (item.key.includes(xKey)) {
        const isSelected = detail.selected.some((s) =>
          s.value === item.key
        );
        return { ...item, selected: isSelected };
      } else {
        return item;
      }
    });

    this.count = this.values.filter((v) => v.selected).length;

    this.field.formControl.patchValue(JSON.stringify(this.values));

    // Update the list of x values that have all the y values selected, in order
    // to enable the 'All toggle' in case.
    // This logic is used in the AreAllYSelected pipe
    if (xKey !== '') {
      // No x values
      if (this.values.filter(i => i.key.includes(xKey)).length === detail.selected.length) {
        this.allSelectedByX = [...this.allSelectedByX, xKey];
      } else {
        this.allSelectedByX = this.allSelectedByX.filter(i => i!== xKey);
      }
    } else {
      // x values exist
      if (this.values.length === detail.selected.length) {
        this.allSelectedByX = [...this.allSelectedByX, ''];
      } else {
        this.allSelectedByX = [];
      }
    }

    if (this.to.required) {
      this.updateValidation();
    }
  }

  onSelectAllChanged(xKey: string, { detail }) {
    this.values
      .filter(item => item.key.includes(xKey))
      .forEach((item) => (item.selected = detail.isOn));

    this.field.formControl.patchValue(JSON.stringify(this.values));

    // Show selected values in hybrid field
    if (xKey !== '') {
      // No x values
      const hybridFieldElement = document.querySelector('#hybrid_' + xKey) as HTMLDsHybridFieldElement;
      if (detail.isOn) {
        hybridFieldElement.value = this.values.filter(i => i.key.includes(xKey)).map(i => i.key);
        this.allSelectedByX = [...this.allSelectedByX, xKey]
      } else {
        hybridFieldElement.value = [];
        this.allSelectedByX = this.allSelectedByX.filter(i => i !== xKey);
      }
    } else {
      // x values exist
      const hybridFieldElement = document.querySelector('#hybrid') as HTMLDsHybridFieldElement;
      if (detail.isOn) {
        hybridFieldElement.value = this.values.map(i => i.key);
        this.allSelectedByX = [...this.allSelectedByX, '']
      } else {
        hybridFieldElement.value = [];
        this.allSelectedByX = [];
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateValidation() {
    if (this.count === 0) {
      this.field.formControl.setErrors({ isNotValid: true });
    } else {
      this.field.formControl.setErrors(null);
    }
  }
}
